var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartCustom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.28 14.47l-2.25-2.25a.751.751 0 00-1.06 0L12 19.19v3.31h3.31l6.97-6.97a.751.751 0 000-1.06zM14.69 21H13.5v-1.19l3.75-3.75 1.19 1.19L14.69 21zm4.81-4.81L18.31 15l1.19-1.19L20.69 15l-1.19 1.19zM13.5 10.5v3H15v-3h-1.5zM10.5 9v4.5H12V9h-1.5zM7.5 6v7.5H9V6H7.5z",
    fill: "#45464F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 22.5H4.5A1.502 1.502 0 013 21V3a1.502 1.502 0 011.5-1.5h12A1.502 1.502 0 0118 3v7.5h-1.5V3h-12v18H9v1.5z",
    fill: "#45464F"
  })));
}
export default SvgChartCustom;